import React from 'react';

import Area from '../../../components/charts/apex/area/Area';
import { SONAR_DATA_KEYS } from '../../../utils/chart';

function Passion({ domainEntries }) {
  //! TEMPORARY SOLUTION
  let tempDomainEntries = domainEntries;

  if (domainEntries.length && !domainEntries[0][SONAR_DATA_KEYS.PASSION]) {
    tempDomainEntries = [];
  }

  return <Area data={tempDomainEntries} dataKey={SONAR_DATA_KEYS.PASSION} customTooltip isShowTrend />;
}

export default Passion;
